import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'

const UnprotectedLayout = () => {
  return (
    <>
      <Header/>
      <div className="min-h-screen bg-gray-50" style={{paddingTop: '79px'}}>
        <Outlet />
      </div>
      <Footer />
    </>
  )
}

export default UnprotectedLayout